<script setup lang="ts">
import HeaderVue from "@/views/components/Header.vue";
// import HeaderClient from "@/views/components/HeaderClient.vue";
import FooterVue from "@/views/components/Footer.vue";
import useAuthStore from "@/stores/auth.ts";
import { useUserStore } from "@/stores/user.ts";
import { onMounted, defineAsyncComponent } from "vue";
import { getUserFromLocalStorage } from "@/utils/functions.ts";
import { IUser } from "@/models/interfaces/interfaces.ts";
import { useAlertsStore } from "@/stores/alerts";
import CookieConsentBanner from '@/views/components/CookieConsentBanner.vue';

// Stores
const auth = useAuthStore();
let userStore = useUserStore();

const NotificationToast = defineAsyncComponent(() => import('@/views/components/NotificationToast.vue'));
const alerts = useAlertsStore();

const props = withDefaults(
  defineProps<{
    canShowFooter?: boolean;
  }>(),
  {
    canShowFooter: true,
  }
);

// Lifecycle Hooks
onMounted(() => {
  if (auth.isLoggedIn) {
    const user = getUserFromLocalStorage()
    if (user) {
      userStore.addUser(user as IUser);
    }
  } 
});
</script>

<template>
  <template v-if="alerts.getSize > 0">
    <NotificationToast />
  </template>
  <HeaderVue />
  <slot></slot>

  <FooterVue v-if="props.canShowFooter"/>
  <CookieConsentBanner></CookieConsentBanner>
</template>
